import { defineAdderOptions } from '@svelte-add/core';

export const options = defineAdderOptions({});
